// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3ZoYM","footer":"ChangeClinic_footer__31wWd"};